import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.type = this.el.getAttribute('data-service');
        this.icon = this.el.querySelector('.c-service-logo_icon');
        this.tl = this.getTL();
    }

    getTL() {
        if (this.type == 'weplay') {
            return this.getWeplayTL();
        }
        if (this.type == 'stopscrollers') {
            return this.getStopscrollersTL();
        }
        if (this.type == 'audiences') {
            return this.getAuciencesTL();
        }
    }

    getWeplayTL() {
        let tl = gsap.timeline({ paused: true, repeat: -1, repeatDelay: 0.2 });
        tl.fromTo(
            this.icon,
            { scale: 0 },
            { scale: 1, ease: 'elastic.out(1,0.7)', duration: 0.8 },
            0
        );
        tl.to(this.icon, { rotate: 360, ease: 'none', duration: 5 }, 0);
        tl.fromTo(
            this.icon,
            { scale: 1 },
            { scale: 0, ease: 'power4.out', duration: 0.4 },
            "-=0.8"
        );
        return tl;
    }

    getStopscrollersTL() {
        let tl = gsap.timeline({ paused: true, repeat: -1 });
        tl.set(this.icon, { transformOrigin: 'top center' });
        tl.fromTo(
            this.icon,
            { scale: 0, y: 0 },
            { scale: 1, y: 0, ease: 'back.out(2)', duration: 0.8 }
        );
        tl.set(this.icon, { transformOrigin: 'bottom center' });
        tl.fromTo(
            this.icon,
            { scale: 1, y: 0, opacity: 1 },
            { scale: 0, y: 10, opacity: 0, ease: 'power4.out', duration: 0.4, delay: 2 }
        );
        return tl;
    }

    getAuciencesTL() {
        let tl = gsap.timeline({ paused: true, repeat: -1, repeatDelay: 0.2 });
        tl.set(this.icon, { transformOrigin: 'top center' });
        tl.fromTo(
            this.icon,
            { scaleX: 0.2, scaleY: 0, y: -20 },
            { scaleX: 1, scaleY: 1, y: 0, ease: 'elastic.out(1,0.7)', duration: 0.8 }
        );
        tl.set(this.icon, { transformOrigin: 'bottom center' });
        tl.fromTo(
            this.icon,
            { scaleX: 1, scaleY: 1 },
            { scaleX: 0.2, scaleY: 0, ease: 'power4.out', duration: 0.4, delay: 2 }
        );
        return tl;
    }

    toggle(e) {
        if (e.way == 'enter') {
            this.tl.play();
        } else {
            this.tl.pause();
        }
    }
}
